/** Eternal City copy, ja. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityJa: Record<string, string> = {
  'city.seoDescription': '活き活きのある町へ行きなさい.皆が日常のルートを守っている.彼らに従え,彼らと話し,あなたなしでの生活が続く人々と一緒に一日を過ごしてください.',
  'city.intro': '町は生きています ここにいる皆が 日常を守っていて 遊びながら時間が過ぎます 地図をクリックして歩きますか 隣にあるリストを使います',
  'city.back': '地球へ戻る',
  'city.connecting': '市門を開く',
  'city.reconnecting': '線を消した 接続を直した',
  'city.offline': '市は手届かないので もう一度やってみてください',
  'city.signinTitle': '入力するにはサインインする',
  'city.signinBody': '町でのあなたの居場所や日記や出会った人々も あなたの記録に保存されています.あなたが遊んでいる間に時間が過ぎて,いくつかの注文は待たない.',
  'city.signinCta': 'サインインする',
  'city.privacy': 'このデータを扱う方法: プライバシーポリシー',
  'city.blocked': '市は今この口座を開放していない. もしそれが間違いだと思うなら,サポートに連絡してください.',
  'city.openElsewhere': 'この街は別のタブで開いている 閉じるかここに再充電する',
  'city.canvasLabel': 'イソメトリックマップ {city}. 隣にあるリストを使って 話したり 歩き回ったり 見たりする',
  'city.hint': '歩くために地面をクリックするか 話すために人をクリックします',
  'city.holiday': '今日: {name}',
  'city.here': 'どこにいるの? {place}.',
  'city.commons.empty': 'これは共有スペースで 他の旅行者はいない',
  'city.commons.here.one': 'これは共有スペースで もう1人の旅行者がここにいます',
  'city.commons.here.other': 'これは共有空間です {count} 他の旅行者がここにいます',
  'city.commons.peer': '旅行の仲間',
  'city.crowd.name': '町人',
  'city.travel.ride': '乗って行く {place} (約 {n} (分)',
  'city.wares.now': '今から説明します {list}',
  'city.wares.none': 'この時には何も用意されていません',
  'city.wares.few': '{name} (左にいくつか)',
  'city.wares.last': '{name} (最後の1つ)',
  'city.places': 'どこかに行って',
  'city.goPlace': '行って {place}',
  'city.dialogueAnnounce': '選択は現れるように発表されます',
  'city.people': '周りにいる人',
  'city.peopleNone': '視界には誰もいない',
  'city.talk': '話す',
  'city.goto': '歩いて',
  'city.away': '{n} 歩いて',
  'city.scenes': '近くで起こっている',
  'city.watch': '加入する',
  'city.props': '周りに見ろ',
  'city.examine': '見て',
  'city.open': 'オープン',
  'city.take': '受け取って',
  'city.menu.open': 'オープン {thing}',
  'city.menu.take': '持ってるものを {thing}',
  'city.menu.walkToThing': '歩いて {thing}',
  'city.dialogue': '会話',
  'city.close': '近く',
  'city.leave': '話しをやめろ',
  'city.menu.talk': '話す {name}',
  'city.menu.walkTalk': '歩いて {name}',
  'city.menu.walkTo': '歩いて {name}',
  'city.menu.walkHere': '歩いて来い',
  'city.menu.swimHere': 'ここに泳いで',
  'city.menu.rowHere': 'ここに並べて',
  'city.mount.down': '降りろ {name}',
  'city.companion.home': '送信する {name} 家庭',
  'city.rumours.title': '噂の掲示板',
  'city.rumours.none': '町の人たちが集まって お酒屋のそばで 話している',
  'city.rumours.said': '言った {name}',
  'city.greet.title': '名前で知られる',
  'city.greet.callMe': '町の人たちがどう呼んでいるか?',
  'city.greet.placeholder': 'あなたの名前',
  'city.greet.none': '誰かに話をして,次回は名前で挨拶します.',
  'city.greet.morning.0': 'おはよう {name}!',
  'city.greet.morning.1': 'おはようございます {name}.',
  'city.greet.morning.2': '早く起きて {name}?',
  'city.greet.afternoon.0': 'こんばんは {name}.',
  'city.greet.afternoon.1': 'こんばんは {name}!',
  'city.greet.afternoon.2': '初めまして {name}.',
  'city.greet.evening.0': '夕方 {name}.',
  'city.greet.evening.1': 'こんばんは {name}!',
  'city.greet.evening.2': '家を出た {name}?',
  'city.greet.night.0': '外に出るのが遅かった {name}.',
  'city.greet.night.1': '暗闇に気をつけろ {name}.',
  'city.greet.night.2': 'まだまだ {name}?',
  'city.greet.morning.0.anon': 'こんにちは 友よ!',
  'city.greet.morning.1.anon': 'おはようございます',
  'city.greet.morning.2.anon': '早く起きてるのか?',
  'city.greet.afternoon.0.anon': 'こんばんは 友達',
  'city.greet.afternoon.1.anon': 'こんにちは!',
  'city.greet.afternoon.2.anon': '初めまして',
  'city.greet.evening.0.anon': '夕方,友よ',
  'city.greet.evening.1.anon': 'こんばんは!',
  'city.greet.evening.2.anon': '家から出たのか?',
  'city.greet.night.0.anon': '外に出るのに遅いよ',
  'city.greet.night.1.anon': '暗闇に気をつけろ',
  'city.greet.night.2.anon': 'まだいるの?',
  'city.market.title': '市場板',
  'city.market.shut': '今何も用意してない',
  'city.market.later': '今日も',
  'city.market.am': '{n} 午前中は',
  'city.market.pm': '{n} 午後から',
  'city.market.eve': '{n} 夕方',
  'city.garden.title': '庭園の土地',
  'city.garden.tend': '土地の管理',
  'city.garden.tended': '雑草を抜いて 土地を水にします',
  'city.garden.already': 'あなたは今日もこの計画を立ててきました',
  'city.garden.tendedNote': '今日もお世話になりました',
  'city.garden.arrive': '労働組合 {crop} これは... {stage}.',
  'city.garden.crop.herbs': '草',
  'city.garden.crop.apples': 'リンゴの木',
  'city.garden.crop.kitchen': 'キッチングリーン',
  'city.garden.crop.cabbages': 'カバノコと豆',
  'city.garden.crop.wheat': '麦畑',
  'city.garden.stage.bare': '冬に裸で',
  'city.garden.stage.sown': '新たに植えられた',
  'city.garden.stage.sprouting': '発芽する',
  'city.garden.stage.growing': '成長する',
  'city.garden.stage.flowering': '花で',
  'city.garden.stage.ripe': '熟成し 準備ができている',
  'city.garden.stage.harvested': '年間収穫した',
  'city.fish.title': '漁業',
  'city.fish.cast': '線を投げて',
  'city.fish.go': '行け',
  'city.fish.here': '良い釣り場だ パネルから線を投げろ',
  'city.fish.casting': '線を並べて待って',
  'city.fish.caught': '何かが噛んで 降りてくる {fish}.',
  'city.fish.got.boot': '古いブーツを巻き回して 投げ返します',
  'city.fish.got.weed': '川の草だけだ',
  'city.fish.got.nothing': '何も噛まない 水は秘密を保ちます',
  'city.fish.casts': '{n}今までの投影',
  'city.fish.none': '魚は夜明けと夕暮れに噛みし 春と秋に噛むのが一番です',
  'city.fish.spot.bank': '川岸',
  'city.fish.spot.jetty': 'ジェティ',
  'city.fish.spot.bridge': 'ミルブリッジ',
  'city.fish.name.perch': 'パーチ',
  'city.fish.name.roach': 'ザクロウ',
  'city.fish.name.trout': 'トラット',
  'city.fish.name.eel': 'イルカ',
  'city.fish.name.pike': 'パイク',
  'city.fish.name.carp': 'カルプ',
  'city.fish.name.minnow': 'ミニノウ',
  'city.fish.name.crayfish': 'クラゲ',
  'city.fish.name.boot': '古いブーツ',
  'city.fish.name.weed': '川の草',
  'city.fish.name.nothing': '何もない',
  'city.lost.title': '失われたと見つかった',
  'city.lost.none': '町の人たちは市場や広場などに物物を捨てて どこにでも物があるなら',
  'city.lost.whose': '属している {name}',
  'city.lost.find': '探す {name}',
  'city.lost.spot': '何か地面に隠れている {thing}',
  'city.lost.pick': '拾い上げ {thing}',
  'city.lost.picked': '聞いてくれ {thing}. - 似通ってる {name}.',
  'city.lost.give': '与えること {thing} 戻る {name}',
  'city.lost.thanks': '{name} 幸せに {thing} 戻った',
  'city.lost.thing.glove': '失われた手袋',
  'city.lost.thing.keys': '鍵のリング',
  'city.lost.thing.locket': '小さな medailant',
  'city.lost.thing.toy': '木製のおもちゃ',
  'city.lost.thing.scarf': '羊毛のシャール',
  'city.lost.thing.purse': '空っぽの財布',
  'city.lost.thing.spectacles': '眼鏡のカップル',
  'city.lost.thing.letter': '折りたたたみの手紙',
  'city.lost.thing.ribbon': '髪帯',
  'city.lost.thing.pipe': '粘土パイプ',
  'city.records.title': '都市記録',
  'city.records.peak': '忙しい今日 {time}, と {n} 町の人たちがいた',
  'city.records.now': 'この時間 {out} 外へ {home} 家にいます',
  'city.records.busiest': '最も忙しい四半期: {district}.',
  'city.records.outTitle': '町の人たちは,時間ごとに',
  'city.records.seenTitle': '周りに見た人は 時ごとに',
  'city.a11y.title': 'アクセシビリティ',
  'city.a11y.text': 'テキストサイズ',
  'city.a11y.size1': '普通のこと',
  'city.a11y.size125': '大きい',
  'city.a11y.size15': '最も大きい',
  'city.a11y.stillOff': '動きを減らす',
  'city.a11y.stillOn': '提案は減った',
  'city.a11y.contrastOff': '高コントラスト',
  'city.a11y.contrastOn': '高対比性',
  'city.tour.welcome.title': 'お待たせしました {city}',
  'city.tour.welcome.body': 'この街は独自の時計で暮らしています 目を覚ますと働くと食べたり寝たりする人がいます',
  'city.tour.walk.title': '歩いている',
  'city.tour.walk.body': 'ロボットは壁やドアを通り抜ける',
  'city.tour.talk.title': '話す',
  'city.tour.talk.body': '人 の 名前 を 見る ため に タップ し,その 人 に 近づい て 行け.近寄った 時,再び タップ し 話 する よう に する.その 人 の 言葉 は 頭 の 側 に 浮かび ます.',
  'city.tour.menu.title': '近づいて見ると',
  'city.tour.menu.body': 'コンピュータの右クリックで 画面にサインを読み,座り,部屋を予約するなど',
  'city.tour.map.title': 'ミニマップ',
  'city.tour.map.body': '角落の小さな地図には 道路や街区や 近くにいる人々 が 映っています. その地図を押して 行き先へ 行くことができます.',
  'city.tour.panel.title': 'あなたのパネル',
  'city.tour.panel.body': 'サイドパネルは,近くにいる人々,あなたが発見した場所,あなたの探求,あなたの日記,その他を列挙します.',
  'city.tour.keys.title': '移動する',
  'city.tour.keys.body': 'キーボードのボタンはロボットが知っているすべての動きを示します',
  'city.tour.done.title': 'それだけ',
  'city.tour.done.body': '楽しんで {city}. サイドパネルから このツアーを再開できます',
  'city.tour.step': '{n} について {total}',
  'city.tour.next': '次は',
  'city.tour.back': '戻る',
  'city.tour.skip': 'ツアーを逃す',
  'city.tour.finish': '探査開始',
  'city.tour.again': '再び街を巡る',
  'city.found.title': '発見された場所',
  'city.found.count': '{n} について {total}',
  'city.found.none': 'ここまで加える場所へ',
  'city.found.new': '発見 {place}',
  'city.board.open': '公共のメモボードを読む',
  'city.board.hint': '他の旅行者がここに残したメモは 自分の短いメモを 固定して リンクはなし',
  'city.board.placeholder': '短信を書いてください',
  'city.board.pin': '紙を貼って',
  'city.board.loading': '掲示板を読んで...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': '書き留めて',
  'city.board.err.signin': 'サインインしてメモを貼って',
  'city.board.err.soon': 'もう1つのメモを貼る前に ちょっと待って',
  'city.board.err.bad': '注記は,リンクなしで200文字までシンプルなテキストでなければならない.',
  'city.board.err.down': '取締役には連絡が取れない',
  'city.room.rent': '部屋を予約する {place}',
  'city.room.move': 'あなたの部屋を移動 {place}',
  'city.room.yours': 'あなたの部屋で {place}',
  'city.room.decorate': '何かここに置く',
  'city.room.remove': '取れ {thing}',
  'city.room.leave': '部屋を譲って',
  'city.room.full': '部屋には余裕がない',
  'city.room.pickTitle': '部屋を装飾する',
  'city.room.pickHint': 'この場所に設定するものを選んで この装置であなたの部屋に残ります',
  'city.room.kind.rug': '織布したカーペット',
  'city.room.kind.candle': 'ろうそく',
  'city.room.kind.flowers': '花の鍋',
  'city.room.kind.painting': '絵画',
  'city.room.kind.plant': '鍋の植物',
  'city.room.kind.chest': '小さな胸',
  'city.room.kind.lantern': 'ランタン',
  'city.room.kind.books': '数冊',
  'city.busk.lute': '{name} 近くにある明るい音が聞こえる',
  'city.busk.fiddle': '{name} 近くにある活き活きのあるロールを切り開く',
  'city.busk.pipe': '{name} 近くでゆっくり空を吹く',
  'city.busk.drum': '{name} 近くで踊る',
  'city.tail.label': 'フォローする {name}',
  'city.tail.title': '尾行 {name} 昼間',
  'city.tail.now': '今度は {activity} について {place}',
  'city.tail.unknown': '彼らの計画はまだ不明だ',
  'city.tail.next': '次は: {place} について {time}, 中 {h} h {m} ミン',
  'city.tail.trail': '追跡された {places}',
  'city.tail.stop': '追いかけるのをやめろ',
  'city.pins.add': 'ピンを追加する',
  'city.pins.tapMap': 'ピンを配置するために地図にタップしてください',
  'city.pins.walk': 'このピンに歩いて',
  'city.pins.note': '{x}, {y} にピン.',
  'city.pins.noteLabel': 'ピンノート',
  'city.pins.remove': 'このピンを取り除け',
  'city.pins.here': 'この場所を地図に貼って',
  'city.compass.north': '北部',
  'city.compass.at': 'x {x},y {y},床 {floor}',
  'city.door.prop': 'ドアを開いて',
  'city.door.close': 'ドアを閉めろ',
  'city.door.unlock': 'ドアを開け',
  'city.door.lock': 'ドアをロックする',
  'city.books.browse': '棚を閲覧する',
  'city.books.shelf': 'シェルフ {place}',
  'city.books.book': '図書',
  'city.books.scroll': 'スロール',
  'city.books.prev': '前記',
  'city.books.back': '棚に戻る',
  'city.books.next': '次は',
  'city.books.page': 'ページ {n} の {of}',
  'city.sign.readSign': '記号を読む',
  'city.sign.readPlaque': 'プレートを読む',
  'city.sign.sign': '塗装された標識',
  'city.sign.plaque': 'ドアの横にある板',
  'city.district.entering': '入り口',
  'city.district.riverside': '川岸 と 低価格 の 市場',
  'city.district.sunwalk': 'ウォーキング',
  'city.district.lanes': 'レーンズ',
  'city.district.monastery': '修道院',
  'city.district.castle': '城',
  'city.district.drains': '古い排水道',
  'city.district.farmlands': '農地',
  'city.photo.enter': '写真モード',
  'city.photo.hint': '写真モード 周りを見渡すためにドラッグし スクリーンショットを撮って保存します',
  'city.photo.leave': 'フォトモードを残す',
  'city.building.who': '住んで働いてる {place}',
  'city.building.live': '住んでる',
  'city.building.work': 'ここには仕事がある',
  'city.building.now': '今すぐ内側',
  'city.building.rooms': '影響を受けます {list}.',
  'city.inspect.about': 'について {name}',
  'city.inspect.close': '近く',
  'city.inspect.unknown': '誰もあなたに話すことはできません {name}.',
  'city.inspect.home': '家庭',
  'city.inspect.work': '作業',
  'city.inspect.none': '知られていない',
  'city.inspect.today': '今日',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'フォローする {name} 昼間',
  'city.overlay.label': 'マップのオーバーレイ',
  'city.overlay.crowd': '群衆',
  'city.overlay.light': 'ライト',
  'city.overlay.noise': '騒音',
  'city.bar.pop': '{n} 住んでる',
  'city.bar.out': '{n} 出て行け',
  'city.bar.season.spring': '春',
  'city.bar.season.summer': '夏',
  'city.bar.season.autumn': '秋',
  'city.bar.season.winter': '冬',
  'city.notebook.title': '聞いたことと学んだこと',
  'city.notebook.all': 'すべて',
  'city.notebook.heard': '聞きました',
  'city.notebook.learned': '学びました',
  'city.notebook.search': 'ノートで調べる',
  'city.notebook.none': '通りで聴いて 人と話して',
  'city.ask.title': '周りを見渡してみてください',
  'city.ask.pick': '誰を探してるの?',
  'city.ask.ask': '尋ねる',
  'city.ask.passerby': '通り過ぎる人',
  'city.ask.nobody': '頼むほど近くにいる人はいない 通りで誰かを見つけて',
  'city.ask.unseen': '{asker} 見ていない {who} 今日のことだ',
  'city.ask.here': '{asker} と言う {who} 近い {place}.',
  'city.ask.go': '行って {who}',
  'city.weather.clear': '晴れた空',
  'city.weather.cloudy.light': '数つの雲',
  'city.weather.cloudy.heavy': '灰色と曇り',
  'city.weather.rain.light': '浅い雨',
  'city.weather.rain.heavy': '激しい雨',
  'city.weather.fog.light': '朝の霧',
  'city.weather.fog.heavy': '厚い霧',
  'city.weather.snow.light': '軽雪',
  'city.weather.snow.heavy': '重雪',
  'city.lamplighter.name': 'ランプライト',
  'city.lamplighter.lighting': '路灯を照らす',
  'city.lamplighter.dousing': '路灯を消す',
  'city.hourglass.title': '砂時計',
  'city.hourglass.stop': '日を止めて',
  'city.hourglass.paused': '日が止まっています',
  'city.hourglass.resume': '行くよ',
  'city.seat.bench': 'ベンチ',
  'city.seat.chair': '椅子',
  'city.seat.sit': '座って {what}',
  'city.inside.crate': '箱',
  'city.inside.barrel': '樽',
  'city.inside.title': '内部で {what}',
  'city.inside.look': '覗いてみてください {what}',
  'city.inside.holds': 'それは {fill}: {list}.',
  'city.factions.title': '都市で立っている',
  'city.factions.wary': '警戒する',
  'city.factions.unknown': '未知',
  'city.factions.noticed': '気づきました',
  'city.factions.trusted': '信頼される',
  'city.factions.honored': '尊敬された',
  'city.factions.done': '完成した任務: {n}.',
  'city.mail.title': '手紙',
  'city.mail.none': 'まだ手紙はない',
  'city.mail.from': 'からの {name}',
  'city.mail.waiting': '回答を待っています {names}.',
  'city.mail.nobody': '誰かを助け,手紙を書ける.',
  'city.mail.write': '手紙を書いて',
  'city.mail.to': '誰に',
  'city.mail.subject': '対象',
  'city.mail.body': 'あなたの手紙',
  'city.mail.send': '送ってくれ',
  'city.mail.untitled': '数行',
  'city.moth.title': '蝶のトレイ',
  'city.moth.trade': '頼むよ',
  'city.moth.yours': '今度は君のものだ',
  'city.spy.title': '静かな仕事',
  'city.cut.skip': '飛び越え',
  'city.party.title': '一緒に遊ぶ',
  'city.party.blurb': 'パーティーを始め 友達とコードをシェアする 共有スペースだけでなく 街のどこでも会える',
  'city.party.start': 'パーティーを始める',
  'city.party.codeLabel': 'パーティーコード',
  'city.party.join': '加入する',
  'city.party.bad': 'パーティーのコードは4から8文字か数字です',
  'city.party.code': 'あなたのパーティーのコードは {code}. 友達と共有して 仲間になれる',
  'city.party.alone': 'あなたのパーティーの誰も今 町にはいない',
  'city.party.here': 'すぐそばに',
  'city.party.away': '{n} ステップ {dir}',
  'city.party.floor': '(フロア {n})',
  'city.party.go': '行って',
  'city.party.leave': 'パーティを去って',
  'city.party.dir.east': '東',
  'city.party.dir.south-east': '東南',
  'city.party.dir.south': '南部',
  'city.party.dir.south-west': '南西',
  'city.party.dir.west': '西',
  'city.party.dir.north-west': '北西',
  'city.party.dir.north': '北',
  'city.party.dir.north-east': '北東',
  'city.print.title': '建物を印刷する',
  'city.print.here': '{name}: {w} による {d} 細胞,床: {n}. 3Dプリンターに STLとして保存する',
  'city.print.none': '3Dプリンター用の STLとして保存する建物やその隣に立っています',
  'city.print.model': 'STLを保存する,モデルスケール (5 mm/セル)',
  'city.print.tabletop': 'STLを保存し,テーブルタップスケール (1インチ/セル)',
  'city.print.note': '壁,床,ドア,階段,窓を 都市が描くように ベースプレートに描いて 片隅に印刷します',
  'city.print.models': '図形および道具,プリント準備:',
  'city.print.busy': '準備する',
  'city.print.model.figure': 'ウォーカーフィギュア,25mmベースで28mm',
  'city.print.model.fountain': '3インチ径の噴水',
  'city.print.model.castle-wall': '城壁の部分,長さ3インチ',
  'city.editor.stl': 'STLを保存する',
  'city.editor.title': '都市地図編集者',
  'city.editor.blurb': '都市地図を床ずつ塗る:壁,街,ドア,水,階段,命名された場所.下記のチェックは,居住都市が使用する地図リーダーで読み取ります.あなたの草案はこのブラウザで保存されます.保存または共有するためのファイルとして輸出します.',
  'city.editor.name': '地図名',
  'city.editor.tools': 'ツール',
  'city.editor.tool.pen': 'ペン',
  'city.editor.tool.rect': 'ブロック',
  'city.editor.tool.room': '部屋',
  'city.editor.tool.fill': '満たす',
  'city.editor.tool.spawn': 'スタートポイント',
  'city.editor.tiles': '土地',
  'city.editor.letter': '手紙',
  'city.editor.placeName': '場所名',
  'city.editor.addPlace': '場所を追加する',
  'city.editor.placeBad': '場所には一文字と名前が必要です',
  'city.editor.floors': '床',
  'city.editor.addFloor': '床を追加する',
  'city.editor.map': '地図',
  'city.editor.width': '幅',
  'city.editor.height': '高さ',
  'city.editor.new': '新しい地図',
  'city.editor.undo': '無効',
  'city.editor.export': '輸出',
  'city.editor.import': '輸入',
  'city.editor.loaded': '地図が載ってる',
  'city.editor.zoom': '拡大する',
  'city.editor.check': 'チェック',
  'city.editor.ok': '清潔に読める {walk} オープンセル {reach} スタート地点からアクセスできます.',
  'city.editor.placeSpots': '{name}: {n} 細胞',
  'city.editor.canvas': '地図キャンバス',
  'city.spy.take': '受け取って',
  'city.spy.again': 'もう一度やってみよう',
  'city.spy.drop': '放っておいて',
  'city.spy.progress': '{n} 百分ける',
  'city.spy.carrying': '紙は持ってる',
  'city.spy.underway': '行くぞ',
  'city.spy.done': 'やった',
  'city.spy.failed': '前回は失敗した',
  'city.menu.look': '見てくれ {thing}',
  'city.menu.street': 'ストリート',
  'city.menu.wall': '壁',
  'city.continue': '継続する',
  'city.goodbye': 'さようなら',
  'city.board.title': '賞金板',
  'city.arrive.rooftops': '屋頂に上がり 廊下が開き 家の間にある板は 足下から裂けていく',
  'city.arrive.museumRoof': '博物館の屋根に 古いイベリーを 引き上げると サンウォーク・プラザは 遊戯板のように 横たわります',
  'city.crier.title': '泣き叫ぶ人のシート',
  'city.crier.today': '今日は {name}.',
  'city.crier.tomorrow': '{name} 明日だ',
  'city.crier.coming': '{name} {n}日以内に',
  'city.crier.stalls': '陽光が昇る時に スタンドで',
  'city.crier.notices': '{n} 賞金板の通知',
  'city.crier.talk': '町の話だ',
  'city.crier.now': '今街で起こっていること',
  'city.board.empty': '今日は何もない 明日再確認する',
  'city.board.posted': '投稿者: {name}.',
  'city.board.postedAt': '投稿者: {name}, 今度は {place}.',
  'city.board.days': '{n} 数日しか残っていない',
  'city.board.find': '見つけろ',
  'city.topics.ask': '{word}?',
  'city.talkWith': '話すこと {name}',
  'city.journal': 'ジャーナル',
  'city.journalNone': 'まだ何も書かれていない',
  'city.quests': 'ローンドと糸',
  'city.questNone': 'まだ誰もいない 人と話して',
  'city.rest': '休憩 {n}分',
  'city.saves.title': '保存されたゲーム',
  'city.saves.slot': 'スロット {n}: {day} {time}, {place}',
  'city.saves.empty': 'スロット {n}: 空',
  'city.saves.save': '保存する',
  'city.saves.load': '負荷',
  'city.saves.sure': '確認するために再びタップします',
  'city.saves.hint': '町はどこにいるか 時刻 人 任務 箱 荷物が戻る',
  'city.restHint': '時間が過ぎて 休憩は1時間しかできない',
  'city.bed.ask': '寝て {bed}?',
  'city.bed.night': '眠っている間に8時間過ぎます 遊びのルールに従って休みます',
  'city.bed.sleep': '眠る',
  'city.bed.notNow': '今じゃダメ',
  'city.bed.tired': 'まだ疲れていない あなたは再び寝ることができます {n} 何時間も',
  'city.bed.asleep': '眠っている 夜は過ぎる',
  'city.bed.offer': 'ここに寝て',
  'city.vitals': '健康',
  'city.bed.woke': '寝てる {bed} 起きて {time}. {change}',
  'city.bed.change': '{label}: {before} について {after}.',
  'city.bed.noRest': '労働組合 {system} ルールでは 休憩に回復ができないので 治る事はありません',
  'city.bed.beds': 'ベッド',
  'city.bed.demoRules': 'ベッドテストのルール: {system}. ルール=Srd-5-2-1,Zwiihanderまたはラットをアドレスに追加して 別の試しに',
  'city.messages': '注記',
  'city.rules': 'ゲームシステム',
  'city.rulesNarrative': '都市を物語として システムを選んで その数字をすべて見る',
  'city.statsFor': '番号',
  'city.sparTitle': '練習戦',
  'city.sparA': '最初の戦闘機',
  'city.sparB': '第二戦闘機',
  'city.sparVs': '反対に',
  'city.sparRun': '戦い',
  'city.sparNote': 'このシステムでのデモだ 町で傷ついた者はいない',
  'city.sparRound': '丸い {n}.',
  'city.zoomIn': '拡大する',
  'city.pivot.left': '視点を左に回す',
  'city.pivot.right': '視点を右に回す',
  'city.pivot.north': '北を向く',
  'city.zoomOut': '拡大する',
  'city.centre': '私を中心に',
  'city.followOn': '続けて',
  'city.followOff': 'フォローする',
  'city.followOnHint': 'カメラがついてる 放っておいて',
  'city.followOffHint': '触って,自分に戻るんだ',
  'city.minimapShow': '地図を表示',
  'city.minimapHide': '地図を隠す',
  'city.minimapOpen': '都市地図をタップして 大きく開きます',
  'city.minimapWalk': '市地図に 歩ける場所をタップして',
  'city.minimapSmall': '地図を小さくする',
  'city.minimapHint': 'そこに歩けるためにタップ',
  'city.chatter.morning.1.a': '急いでいるなら 角のオーブンに新鮮なパンが',
  'city.chatter.morning.1.b': '匂いがしたから ほっといてくれ',
  'city.chatter.morning.2.a': '早起きした',
  'city.chatter.morning.2.b': '鐘が鳴ったんだ いつも起きてる',
  'city.chatter.morning.3.a': '車がゲートを通って来たのか?',
  'city.chatter.morning.3.b': '3人,一人が橋で車輪を失いました',
  'city.chatter.morning.4.a': '今朝は寒かった',
  'city.chatter.morning.4.b': '川の霧は昼までに燃え尽きる.',
  'city.chatter.morning.5.a': 'どこに行ってるの?',
  'city.chatter.morning.5.b': '市場へ,良いリンゴが消える前に.',
  'city.chatter.afternoon.1.a': 'スタンドで忙しい日.',
  'city.chatter.afternoon.1.b': '忙しくて 足が落ちてしまった',
  'city.chatter.afternoon.2.a': '今日はタナーを見ましたか?',
  'city.chatter.afternoon.2.b': '1時間前に水に降りた',
  'city.chatter.afternoon.3.a': '今日は太陽が優しい.',
  'city.chatter.afternoon.3.b': '雨が降ってる 膝で感じる',
  'city.chatter.afternoon.4.a': '漁師はに何を欲していたのか?',
  'city.chatter.afternoon.4.b': '太ったんだ 代わりにナップを買った',
  'city.chatter.afternoon.5.a': '新車ですか?',
  'city.chatter.afternoon.5.b': '新しい車輪がまだ古い車輪のように鳴り響いている',
  'city.chatter.evening.1.a': '家に帰る?',
  'city.chatter.evening.1.b': '夕食は自分で作れない.',
  'city.chatter.evening.2.a': 'ランプが灯る',
  'city.chatter.evening.2.b': 'また遅刻した',
  'city.chatter.evening.3.a': '今夜,タバーンにいるの?',
  'city.chatter.evening.3.b': '妻が許してくれれば そうだ',
  'city.chatter.evening.4.a': '長い日',
  'city.chatter.evening.4.b': 'みんなそうなの 今年もね',
  'city.chatter.evening.5.a': '今夜 シャッターを閉めろ',
  'city.chatter.evening.5.b': 'いつもそうするけど 風はどっちも揺れる',
  'city.chatter.night.1.a': '誰がそこに行く?',
  'city.chatter.night.1.b': '俺だけ ランタンを置いて',
  'city.chatter.night.2.a': '眠っているはずよ',
  'city.chatter.night.2.b': 'あなたもそうするべきよ',
  'city.chatter.night.3.a': '水辺で何か聞いたか?',
  'city.chatter.night.3.b': '猫はいつも猫です',
  'city.chatter.night.4.a': '静かな夜',
  'city.chatter.night.4.b': '続けていきましょう',
  'city.chatter.any.1.a': 'ニュースを聞いたか?',
  'city.chatter.any.1.b': 'いつでもニュースがある',
  'city.chatter.any.2.a': 'お疲れ様でした',
  'city.chatter.any.2.b': 'そして君にも',
  'city.chatter.any.3.a': '私のいとこは 古い塔は 鬼が宿っていると誓う.',
  'city.chatter.any.3.b': 'あなたのいとこは多くのことを誓う.',
  'city.chatter.any.4.a': '価格が上昇し続けています.',
  'city.chatter.any.4.b': 'そして私の給料は 止まらない',
  'city.chatter.any.5.a': '池に気をつけろ',
  'city.chatter.any.5.b': '遅すぎる とにかくありがとう',
  'city.chatter.any.6.a': 'みんなの知らない人って?',
  'city.chatter.any.6.b': 'じっと見ないで 粗末だ',
  'city.chatter.any.7.a': 'お母さんはどうですか?',
  'city.chatter.any.7.b': 'ありがとう 怒らせてくれて',
  'city.chatter.any.8.a': '飲み物を借りてるんだろ?',
  'city.chatter.any.8.b': '2 計り知ったら',
  'city.inventory.title': '荷物',
  'city.inventory.subtitle': 'Montkelian 袋',
  'city.inventory.close': '荷物を閉じる',
  'city.inventory.tabs': '包装部分',
  'city.inventory.tab.inventory': '備品',
  'city.inventory.tab.journal': 'ジャーナル',
  'city.inventory.tab.map': '地図',
  'city.inventory.empty': '荷物が空いてる 旅行中に見つけたものは このポケットに収納される',
  'city.inventory.slots': 'ポケット',
  'city.inventory.slotEmpty': 'ポケット {n},空っぽ',
  'city.inventory.slot.headgear': '首飾り',
  'city.inventory.slot.helmet': 'ヘルメット',
  'city.inventory.slot.hat': '帽子',
  'city.inventory.slot.hood': 'ハード',
  'city.inventory.slot.amulet': 'アミュレット',
  'city.inventory.slot.cloak': 'カーボン',
  'city.inventory.slot.tabard': 'タバード',
  'city.inventory.slot.pelt': '毛皮',
  'city.inventory.slot.armor': '装甲',
  'city.inventory.slot.plate': 'プレート',
  'city.inventory.slot.robe': 'ローブ',
  'city.inventory.slot.jerkin': '馬鹿げてる',
  'city.inventory.slot.hide': '隠れ',
  'city.inventory.slot.girdle': 'ゲイル',
  'city.inventory.slot.belt': 'ベルト',
  'city.inventory.slot.bracers': 'ブレーカー',
  'city.inventory.slot.gloves': '手袋',
  'city.inventory.slot.mainHand': '主手',
  'city.inventory.slot.offHand': '手を離す',
  'city.inventory.slot.twoHand': '両手',
  'city.inventory.slot.sword': '剣',
  'city.inventory.slot.shield': '盾',
  'city.inventory.slot.staff': 'スタッフ',
  'city.inventory.slot.focus': '集中する',
  'city.inventory.slot.ring': 'リング',
  'city.inventory.slot.leggings': 'レギング',
  'city.inventory.slot.greaves': 'グレーブス',
  'city.inventory.slot.boots': '靴',
  'city.inventory.item.sword': '剣',
  'city.inventory.item.shield': '盾',
  'city.inventory.item.knife': 'ナイフ',
  'city.inventory.item.axe': '斧',
  'city.inventory.item.tabard': 'タバード',
  'city.inventory.item.cape': 'ケープ',
  'city.inventory.item.ring': 'リング',
  'city.inventory.class.default': '旅行者',
  'city.inventory.class.fighter': '戦闘機',
  'city.inventory.class.paladin': 'パラディン',
  'city.inventory.class.berserker': 'ベルサーカー',
  'city.inventory.class.wizard': '魔法使い',
  'city.inventory.class.rogue': '暴徒',
  'city.inventory.slotFree': '空っぽ',
  'city.inventory.gear': '何を着ているか',
  'city.inventory.view': '展示',
  'city.inventory.viewGear': '磨いた',
  'city.inventory.viewPockets': 'ポケット',
  'city.inventory.avatarHint': 'アバターから別のアバターを選んでください',
  'city.inventory.soon.journal': 'あなたの日記は空白です 募集するクエストとメモはここに書いてあります',
  'city.inventory.soon.map': '折りたたたみの地図は ここに保管され, あなたが行った場所が記されています.',
  'city.inventory.hint': '荷物を開くために自分を叩いて',
  'city.avatar': 'アバター',
  'city.avatarLabel': 'アバターを選んで',
  'city.avatar.robot': 'ロボット',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'パラディン',
  'city.avatarCloth': '服',
  'city.avatarClothHint': 'カップとタバードが動いている',
  'city.soundOn': '音響を入れ',
  'city.soundOff': '音を消す',
  'city.musicOn': '音楽を演奏する',
  'city.musicOff': '音楽を止めて',
  'city.walkSpeed': '速度',
  'city.walkSpeedLabel': '歩行速度',
  'city.walkSpeedValue': '{n}x',
  'city.me': '私を',
  'city.quality': '質量',
  'city.qualityAuto': '自動 ({tier})',
  'city.tier.low': '低値',
  'city.tier.medium': '中間',
  'city.tier.high': '高い',
  'city.robot.keys': 'ロボットキー',
  'city.robot.title': 'ロボットキー',
  'city.robot.intro': '鍵を押すかここを押すと ロボットは 近くにいる皆に見られるようにします ショーの目的で ゲームの変更はありません',
  'city.robot.close': '近く',
  'city.robot.jumpNote': '空中にスペースを再押して 跳ねます',
  'city.robot.spellNote': '呪文モードでは 1, 2 と 3 は攻撃ではなく 呪文は速く 呪文が最初に 充電します',
  'city.robot.climbNote': '階段,梯子,イイヴリー,または排水管を登る.また,階段を登ったり,タップしたりすることができます.',
  'city.robot.walkNote': 'W,A,S,Dは,北,西,南,東を歩いて歩きます. 鍵を握って歩いて続けます.矢印の鍵も同じようにします.',
  'city.robot.walk.north': '北へ歩いて',
  'city.robot.walk.west': '西へ歩いて',
  'city.robot.walk.south': '南へ歩いて',
  'city.robot.walk.east': '歩いて東へ',
  'city.stairs.label': '階段を上って',
  'city.stairs.up': '上へ',
  'city.stairs.down': '下へ',
  'city.stairs.goUp': '階に上がって',
  'city.stairs.goDown': '一階下ろして',
  'city.robot.toggleNote': '武器モード 呪文モード スニーク ダンス ダウン 再び押すまで続けます',
  'city.robot.typing': '鍵は箱に入力している間に何もしない.',
  'city.robot.inSpell': '呪文モード: {act}',
  'city.robot.otherwise': 'そうでない場合: {act}',
  'city.robot.pad': '行動',
  'city.robot.padShow': 'アクションパッドを表示する',
  'city.robot.padHide': 'アクションパッドを隠す',
  'city.robot.padTouch': '(タッチスクリーン向け)',
  'city.robot.noLadder': '近くには階段や階段がない',
  'city.robot.act.jump': '跳ね',
  'city.robot.act.double-jump': '二重ジャンプ',
  'city.robot.act.dodge': '逃げる',
  'city.robot.act.block': 'ブロックまたは防御',
  'city.robot.act.parry': 'パリー',
  'city.robot.act.weapon-mode': '武器モード',
  'city.robot.act.spell-mode': '呪文モード',
  'city.robot.act.slash': 'スラッシュ',
  'city.robot.act.thrust': '推進力',
  'city.robot.act.flurry': 'フルリー',
  'city.robot.act.cast': 'キャスト',
  'city.robot.act.cast-spell': '呪文',
  'city.robot.act.megacast': 'メガキャスト',
  'city.robot.act.duck': 'パック',
  'city.robot.act.sneak': '潜入する',
  'city.robot.act.sing': '歌う',
  'city.robot.act.dance': '踊る',
  'city.robot.act.barf': '臭い',
  'city.robot.act.fall': '落ちたり立ち上がったり',
  'city.robot.act.climb-up': '登る',
  'city.robot.act.climb-down': '降りる',
  'city.robot.act.hurt': '撃った',
  'city.robot.act.kneel': '跪いて立ち上がる',
  'city.robot.act.bow': '弓',
  'city.robot.act.cheer': '勝利を祝い',
  'city.panelShow': 'パネル表示',
  'city.phone.menu': 'メニュー',
  'city.phone.close': 'メニューを閉じる',
  'city.phone.view': '地図',
  'city.phone.sound': '音とペース',
  'city.phone.people': '誰かを探す',
  'city.phone.more': '他のすべて',
  'city.phone.hint': '地面を叩いて歩いて 話し相手を叩いて',
  'city.phone.gotIt': 'わかった',
  'city.panelHide': '隠すパネル',
  'city.canvasLabel3d': '地図 {city} 上から角度から見える. 周りを見渡すには引っ張って,拡大するには絞り込むかスクロールする,歩くか話すためにタップする. パネルにはすべての人とすべてがリストされています.',
  'city.dock.label': '探す人々',
  'city.dock.go': '歩いて {name}',
  'city.dock.walking': '歩いて行く {name}',
  'city.dock.toPlace': '歩いて行く {name} について {place}',
  'city.dock.cancel': '止まるために地面を叩く',
  'city.rigDebug.open': '{name} の動きをデバッグする',
  'city.rigDebug.title': '装置のデバッグ: {name}',
  'city.rigDebug.close': '近く',
  'city.rigDebug.move': '移動する',
  'city.rigDebug.facing': '面接する',
  'city.rigDebug.allMoves': 'すべての動き',
  'city.rigDebug.allFacings': 'すべての面',
  'city.rigDebug.cycling': 'サイクリング, {s}sそれぞれ',
  'city.rigDebug.play': '演奏する',
  'city.rigDebug.pause': '休憩',
  'city.rigDebug.back': '1 フレームを後退する',
  'city.rigDebug.forward': '1 フレームを前進させる',
  'city.rigDebug.speed': '速度',
  'city.rigDebug.hint': 'フレームごとにステップを止めて 外をタップするか,エスケープを押して閉じる.',
  'city.rigDebug.anim.idle': '怠け者',
  'city.rigDebug.anim.walk': '歩いて',
  'city.rigDebug.debug': 'デバッグ',
  'city.rigDebug.viewLabel': 'ビュー',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': '均等性',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': '向き {dir}',
  'city.rigDebug.cell': 'ライン {row},フレーム {col}',
  'city.rigDebug.loading': '負荷',
  'city.rigDebug.clip': 'クリップ',
  'city.rigDebug.allClips': 'すべてのクリップ',
  'city.rigDebug.noClips': 'クリップがない',
  'city.rigDebug.layers': '展示',
  'city.rigDebug.show.model': 'モデル',
  'city.rigDebug.show.bones': '骨',
  'city.rigDebug.show.pieces': 'パーツ',
  'city.rigDebug.boneCount': '{n} 骨',
  'city.rigDebug.no3d': '3D表示は この画面で起動できませんでした',
  'city.rigDebug.hint3d': 'カメラを引っ張って 画面を切り替えるか ストップして 画面を押すか 画面を閉じるか',
  'city.rigDebug.standIn': '{name} 図表に表示されている. {body} 彼女の身体が準備されるまで',
  'city.rigDebug.archive': 'ファイル',
  'city.rigDebug.archivePose': 'ポーズプレビュー: どのように {name} 動いている',
  'city.pose.open': '{name}の動きを見て',
  'city.pose.robot': 'あなた (ロボットの代理人)',
  'city.pose.you': 'あなた',
  'city.pose.see': '動いているのを見て',
  'city.pose.youTitle': '移動する方法を',
  'city.pose.openYou': '動いているのを見て',
  'city.pose.title': 'どういうこと? {name} 動いている',
  'city.pose.allTitle': 'すべてのポーズ',
  'city.pose.all': 'ポーズをすべて表示する',
  'city.pose.one': 'ただ... {name}',
  'city.pose.close': '近く',
  'city.pose.hint': '外にタップして閉じる',
  'city.pose.loading': '積載',
  'city.pose.anim.idle': '怠け者',
  'city.pose.anim.walk': '歩いて',
  'city.pose.anim.talk': '話す',
  'city.pose.anim.sit': '座って',
  'city.pose.anim.run': '走る',
  'city.pose.drag': '引いて回す',
  'city.pose.gait': '運動',
  'city.pose.model': '{name} 3Dで',
  'city.pose.dir.SW': '南西向き',
  'city.pose.dir.SE': '東南向き',
  'city.pose.dir.NE': '東北向き',
  'city.pose.dir.NW': '北西向き',
  'city.demoLink': 'レンダーデモを開く',
  'city.demoTitle': 'レンダー デモ',
  'city.demoNote': '3Dの街の先見映像で 歩行者がいた',
  'city.demoTime': '日中の時間',
  'city.demoSeason': '季節',
  'city.demoPlay': '時計を動かす',
  'city.demoPause': '時計を止めて',
  'city.demoTower': 'テストタワー',
  'city.demoTowerNote': '4 階建て の 建物 で,室内 の 景色 を 確認 する ため に 設置 さ れ て い ます.その 中 で,あなた の 上 の 階 は 切り離され,あなた の 立っ て いる 場所 から 見え ない もの は 灰色 に 染まり ます.',
  'city.demoGoTower': '塔まで歩いて',
  'city.demoFloor': '床: {floor}',
  'city.demoFloor0': '土地',
  'city.demoFloor1': '第2回',
  'city.demoFloor2': '第3回',
  'city.demoFloor3': '第4回',
  'city.demoFloor4': '屋根',
  'city.demoWindow': '3階の窓',
  'city.demoRoom': '3階室内室',
  'city.demoUp': '階に上がって',
  'city.demoDown': '床を下ろして',
  'city.makeWay.polite': '許してくれ',
  'city.makeWay.gruff': '歩いているところを気をつけて',
  'city.makeWay.immovable': '動かない',
  'city.makeWay.busy': '道を注意して',
  'cascade.seoTitle': 'カスケードデバッグ',
  'cascade.title': 'カスケードデバッグ',
  'cascade.intro': '図形を形作るすべてのプロンプトは芸術を生み出します 図形の側面はシステムからアートディレクターまで行きます 継承の側面は,各シート根から,種まで,それらの上に座っている血統まで,全分類です. その全文を読むために任意の行を開きます.',
  'cascade.readOnly': 'この画面の何も 提示を変更することはできません.',
  'cascade.fetchedAt': 'コンテンツ API から読み取れる {time}',
  'cascade.refresh': '読み直す',
  'cascade.loading': '両方とも読み...',
  'cascade.error': 'コンテンツ APIのカスケッドは読み取れなかった もう一度やってみよう',
  'cascade.forbidden': 'この画面はサイト管理者向けです.アカウントはログインされていますが,管理者の役割はありません.',
  'cascade.style.title': 'スタイルのカスカード',
  'cascade.style.subtitle': 'システム,出版社,製品ライン,設定,メディアタイプ,書籍およびアートディレクター. 各行は,その上のより広い行から継承されます.',
  'cascade.style.focus': '鎖をフォローして',
  'cascade.style.counts': '{nodes} スタイル行 {edges} 接続 {media} メディアテンプレート',
  'cascade.taxa.title': '継承者カスカッド',
  'cascade.taxa.subtitle': '各ノードは,その上のノードから受け継ぐすべてのものに独自のプロンプトを追加します.',
  'cascade.taxa.group': '迅速なグループ',
  'cascade.taxa.find': 'タクソンや血統を見つけ',
  'cascade.taxa.findPlaceholder': 'ホモ,テラナ,一族の名前...',
  'cascade.taxa.counts': '{taxa} タックス, {prompts} タックスンプロンプト, {lineages} 血統',
  'cascade.taxa.shardCounts': '{taxa} タクソン {prompts} 列を提示する',
  'cascade.taxa.truncated': 'コンテンツ API はこのシェードのプロンプトリストを締めくくったので,ここにはいくつかの行が欠けている可能性があります.',
  'cascade.taxa.emptyShards': 'タクソンがまだない碎片: {names}',
  'cascade.taxa.orphans': '樹木にない分類を指す系',
  'cascade.taxa.noOwn': 'このグループには 緊急事態は起きない',
  'cascade.taxa.inherits': '上からの遺産',
  'cascade.taxa.inheritsNothing': '継承されたものはない 鎖が始まる場所です',
  'cascade.taxa.through': 'このノードで構成される',
  'cascade.taxa.lineages': 'この種の血統',
  'cascade.level.system': 'システム',
  'cascade.level.publisher': '出版社',
  'cascade.level.product_line': '製品ライン',
  'cascade.level.setting': '設定',
  'cascade.level.media': 'メディアタイプ',
  'cascade.level.book': '図書',
  'cascade.level.art_director': 'アートディレクター',
  'cascade.empty.system': 'このチェーンにはシステムスタイルの列がない.',
  'cascade.empty.publisher': '編集者のスタイルはまだありません このレベルは空です',
  'cascade.empty.product_line': 'このチェーンには製品ラインのスタイルの列がない.',
  'cascade.empty.setting': 'このチェーンには スタイルの列が設定されない',
  'cascade.empty.media': 'このチェーンにはメディアタイプのテンプレートが適用されません.',
  'cascade.empty.book': '本のスタイルは この設定から 取れません',
  'cascade.empty.art_director': 'この連鎖に 芸術監督が繋がっていない',
  'cascade.missing': '欠けているレベル',
  'cascade.others': 'このレベルでの他の行 ({count})',
  'cascade.mediaSpeciesNote': '{count} 種模様は,継承側,その血統の下に示されています.',
  'cascade.field.id': 'id',
  'cascade.field.scope': '適用範囲',
  'cascade.field.scopeId': '範囲 ID',
  'cascade.field.group': 'グループ',
  'cascade.field.mediaType': 'メディアタイプ',
  'cascade.field.prompt': '速やかに',
  'cascade.field.negative': '負',
  'cascade.field.defaults': 'デフォルト',
  'cascade.field.refs': '参照画像',
  'cascade.field.chars': '{count} 文字',
  'cascade.field.empty': '空っぽ',
  'cascade.facet.art_direction': '核',
  'cascade.facet.art_direction_character': '性格',
  'cascade.facet.art_direction_scene': 'シーンは',
  'cascade.facet.art_direction_interface': 'インターフェイス',
  'cascade.facet.art_direction_cartography': 'カートグラフィー',
  'cascade.facet.art_direction_audiobook': 'オーディオブック',
  'cascade.facet.art_direction_movie': '映画',
  'cascade.facet.art_direction_short': '短編',
  'cascade.facet.art_direction_tvshow': 'テレビ番組',
  'cascade.composed.title': '構成する {name}',
  'cascade.composed.layers': '幅から狭い層',
  'cascade.composed.preview': '構成画像プロンプト',
  'cascade.composed.previewNote': 'この画面に上記の行からカスケード順に組み立てられた:スタイルコア,文字面,メディアテンプレート,タクソン特征,その後,プリンットラインは生成機がコードに追加します.ライブ生成機はフレームと主題テキストも追加します.',
  'cascade.composed.negative': '複合負',
  'cascade.composed.fromCode': 'コードで追加され,列に保存されない',
  'cascade.flags.duplicates': '二度言った',
  'cascade.flags.conflicts': '提示書にも表示される否定的な用語',
  'cascade.flags.none': '繰り返される文や 否定的な用語は 提示に矛盾しない',
  'cascade.flags.in': '中 {sources}',
  'cascade.source.styleCore': 'スタイルコア',
  'cascade.source.styleCharacter': 'スタイルの性格の側面',
  'cascade.source.media': 'メディアテンプレート {scope}',
  'cascade.source.taxon': 'タクソン {rank} {value}',
  'cascade.source.printSafe': '印刷行 (コード)',
  'cascade.rank.domain': '域名',
  'cascade.rank.kingdom': '王国',
  'cascade.rank.phylum': 'フィルム',
  'cascade.rank.class': 'クラス',
  'cascade.rank.ordem': '順序',
  'cascade.rank.family': '家族',
  'cascade.rank.genus': '属',
  'cascade.rank.species': '種',
  'cascade.rank.shard': '片切り',
}
